<div
  [class]="
    'flex flex-col justify-center items-center font-roboto-400 text-17 text-grey-16 max-sm:text-12 gap-3 max-sm:gap-1 ' +
    classes
  "
>
  <img
    alt="no-data"
    [src]="urlIcon + 'empty.svg'"
    class="max-sm:max-w-[155px]"
  />
  <span>{{ message | translate }}</span>
</div>
